/* import __COLOCATED_TEMPLATE__ from './default.hbs'; */
import Component from '@glimmer/component';

import { Button } from '@repo/design-system-kit/components/button/button';
import { LottiePlayer } from '@repo/design-system-kit/components/lottie-player/lottie-player';
import errorLottie from '@repo/visual-assets/dotlottie/lottie_pop_general_error404.lottie';
import styles from './default.module.css';

export default class FourthlineErrorsDefaultComponent extends Component {
  button = Button;
  styles = styles;
  errorLottie = errorLottie;

  lottiePlayer = LottiePlayer;
}
